import { createAsyncThunk } from '@reduxjs/toolkit'
import { debouncedGetSuggestsQuery } from 'feature/DaData/getSuggestsQuery'
import { RootState } from 'store/types'

// получить экземпляр предполагаемого адреса по координатам геолокации
export const getSuggestQueryByUserGeo = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  string,
  { state: RootState }
>('address/getSuggestQueryByUserGeo', async suggestQuery => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res = await debouncedGetSuggestsQuery(suggestQuery)
    return res
  } catch (error) {
    throw error
  }
})
